export default __webpack_public_path__ + "assets/c491cf83800f3d4424d9c9b552a8e1a3.svg";